import HomeSeo from './components/HomeSeo';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Opportunity from './components/Opportunity';
import WhyListWithUs from './components/WhyListWithUs';
import ZeroRisk from './components/ZeroRisk';
import HowItWorks from './components/HowItWorks';
import IdealVilla from './components/IdealVilla';
import AboutConcept from './components/AboutConcept';
import EarlyPartner from './components/EarlyPartner';
import LeadForm from './components/LeadForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen font-inter bg-white">
      <HomeSeo />
      <Navbar />
      <main>
        <Hero />
        <Opportunity />
        <WhyListWithUs />
        <ZeroRisk />
        <HowItWorks />
        <IdealVilla />
        <AboutConcept />
        <EarlyPartner />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
